// pipe: frontend wave F5 — Listings sidebar entry (links to the back-office listings grid; the
// in-family nav reaches the storefront orders). Cloned from records-button.tsx / work-button.tsx
// (verbatim shape) — only the route, the active-path prefix, the icon, the label key, and the
// testid differ. NOT admin-gated: the server 403s unauthorized reads and the screens render the
// localized load-error state.
import { useI18n } from '@affine/i18n';
import { TagIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const ListingsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any /listings* route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/listings');

  return (
    <MenuLinkItem icon={<TagIcon />} active={active} to={'/listings'}>
      <span data-testid="pipe-listings-nav">
        {t['com.affine.pipe.listings.nav']()}
      </span>
    </MenuLinkItem>
  );
};
